import { FetchMethod } from 'ts/common/hooks';
import useMfa from './useMfa';
import { setBaseUrl, useStudioApiFetch } from './useStudioApiFetch';
import { setBrandId, useStudioV2ApiFetch } from './useStudioV2ApiFetch';

export { FetchMethod, setBaseUrl, setBrandId, useStudioApiFetch, useStudioV2ApiFetch, useMfa };
export default { useStudioApiFetch };
